import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { TradeCategory } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AddEditTradeCategoryComponent } from 'src/app/modals/add-edit-trade-category/add-edit-trade-category.component';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { TradeService } from 'src/app/services/trade.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-admin-admin-trade-categories',
  templateUrl: './admin-admin-trade-categories.component.html',
  styleUrl: './admin-admin-trade-categories.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminAdminTradeCategoriesComponent {
  constructor(
    private ToastService: ToastService,
    private TradeService: TradeService,
    private ModalService: NgbModal,
    private UtilityService: UtilityService,
    private AuthService: AuthService
  ) {}

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['edit', 'delete']
  };
  suppliedGridQuery: GenericObject = {};
  reloadGrid: boolean = true;

  LoggedInUser = this.AuthService.getUser();

  hasValidEditPermission() {
    if (this.LoggedInUser) {
      const { UserAccountRole: { role } = {} } = this.LoggedInUser;

      return role && new Set(['ADMIN_ADMIN', 'ADMIN_FRAUD_TEAM']).has(role);
    }

    return false;
  }

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: TradeCategory;
  }) {
    const { id } = rowData;

    if (action === 'edit') {
      this.addEdit(rowData);
    }

    if (action === 'delete') {
      const { componentInstance, result } = this.ModalService.open(
        ConfirmModalComponent,
        { centered: true, size: 'md' }
      );

      Object.assign(componentInstance, {
        displayText: 'Are you sure you want to delete this trade category?'
      });

      from(result).subscribe({
        next: (confirm) => {
          if (confirm) {
            this.TradeService.deleteTradeCategory(
              this.UtilityService.stringifyObjectsInQueryObject({
                id
              })
            ).subscribe({
              next: () => {
                this.ToastService.addSuccessToast(
                  'Success',
                  'Successfully deleted trade category.'
                );
                this.reloadGrid = true;
              }
            });
          }
        }
      });
    }
  }

  addEdit(existingTradeCategory?: TradeCategory) {
    const { componentInstance, result } = this.ModalService.open(
      AddEditTradeCategoryComponent,
      { centered: true, size: 'md' }
    );
    const tradeCategory = existingTradeCategory
      ? existingTradeCategory
      : new TradeCategory({});

    Object.assign(componentInstance, { TradeCategory: tradeCategory });

    from(result).subscribe({
      next: () => {
        this.save(tradeCategory);
      }
    });
  }

  save(TradeCategory: TradeCategory) {
    if (!TradeCategory) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. No trade category found.',
        { returnError: true }
      );
    }

    this.TradeService.saveTradeCategory(TradeCategory).subscribe({
      next: () => {
        this.ToastService.addSuccessToast(
          'Success',
          'Successfully saved trade category.'
        );
        this.reloadGrid = true;
      }
    });
  }
}
